<template>
  <div class="industry-timeline">
    <div class="graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
      <h1>History of the Medical Device Industry</h1>
      <div class="timeline-wrapper" :class="{ 'timeline-wrapper--collapsed': isCollapsed }">
        <div class="timeline__inner">
          <div v-for="(event, index) in timelineData" :key="index" class="timeline__element">
            <p class="timeline__element__date">
              <span class="timeline__element__date__dot"></span>{{ event.date }} | {{ event.location }}
            </p>
            <p class="timeline__element__event-description">{{ event.descriptionOfEvent }}</p>
          </div>
        </div>
        <p class="graphic-credit">Dean Starkman and Delphine Reuter/ICIJ</p>
      </div>
      <button class="show-more-button" v-on:click="expandGraphic" :class="{'show-more-button--hidden' : !isCollapsed}">Show more</button>
    </div>
  </div>
</template>

<script>
import timelineData from '../assets/timeline.json'

export default {
  name: 'IndustryTimeline',
  data () {
    return {
      timelineData,
      isCollapsed: true,
    }
  },
  methods: {
    expandGraphic: function () {
      this.isCollapsed = !this.isCollapsed
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .timeline-wrapper--collapsed {
    height: 360px;
    overflow: hidden;
  }
  .timeline__inner {
    border-left: 1px solid $punch;
    margin-left: 4px;
  }
  .timeline {

    &__element {
      padding-left: $spacer;
      position: relative;

      &__date {
        font-size: .8em;
        margin-bottom: .2rem;

        &__dot {
          box-sizing: content-box;
          border: 5px solid white;
          background: $punch;
          border-radius: 50%;
          display: inline-block;
          height: 9px;
          width: 9px;
          position: absolute;
          left:-9px;
        }
      }
    }

    &__event-description {
      padding-left: 13px;
    }
  }

  .show-more-button {
    background: $blue;
    padding: 8px 15px;
    border-radius: 7px;
    margin: auto;
    display: block;
    color: #fff;
    font-weight: bold;
    border: none;
    margin-top: 12px;
    &--hidden {
      display: none;
    }
  }
</style>
